import { getWindow } from "@faire/web--source/common/getWindow";
import { BAIT_IDS, BAIT_DIV_STYLES } from "./consts";
export var insertAdblockBait = function() {
    var dataContainer = getWindow().document.createElement("div");
    var baitElements = [];
    BAIT_IDS.forEach(function(bannerId) {
        baitElements.push('<div id="'.concat(bannerId, '" data-test-id="').concat(bannerId, '" style="').concat(BAIT_DIV_STYLES, '"></div>'));
    });
    dataContainer.innerHTML = baitElements.join("");
    getWindow().document.body.appendChild(dataContainer);
};
